import React from 'react';
import PropTypes from 'prop-types';
import {emitEdapEvent, EVENTS} from "../../utils/emit-edap-event";
import {insertAdBlockTestScript, insertAdsLoaderScripts, removeAdsScripts} from '../../utils/ads-config'

export const Context = React.createContext(null);

export class MesoAdsContext extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allowAds: false,
            gaiaId: props.gaiaId,
            isBrowser: typeof window !== 'undefined'
        };

        this.trackAdsViewByIframeClick = this.trackAdsViewByIframeClick.bind(this);
        this.trackAdsUnitState = this.trackAdsUnitState.bind(this);
        this.fireAdBlockStatus = this.fireAdBlockStatus.bind(this);

        const {isBrowser} = this.state;
        if (isBrowser && props.isAdsEnabled) {
            window.addEventListener('AD_BLOCK_STATUS', this.fireAdBlockStatus);
            insertAdBlockTestScript();
            insertAdsLoaderScripts();
        }
    }

    fireAdBlockStatus({detail:{isAdBlocked}}) {
        if(isAdBlocked) {
            this.setState({allowAds: false});
            emitEdapEvent(EVENTS.BLOCKED);
            window.meso.logging.push('Adblock: true');
        } else {
            this.setState({allowAds: true});
            window.meso.logging.push('Adblock: false');
        }
    }

    trackAdsViewByIframeClick() {
        const {gaiaId} = this.props;
        if (document.activeElement.tagName === 'MESO-DISPLAY-AD' || document.activeElement.tagName === 'MESO-NATIVE') {
            const mesoElement = document.activeElement;

            const { adunitState = {} } = this.state || {};
            const adDetail = adunitState[mesoElement.getAttribute('path')] || {};

            emitEdapEvent(EVENTS.SELECTED, {
                gaia_id: gaiaId,
                ad_id: adDetail.adId,
                ad_type: adDetail.adType,
                ad_placement: mesoElement.getAttribute('slot') || mesoElement.getAttribute('adslot'),
                ad_uci: mesoElement.getAttribute('path') || mesoElement.getAttribute('adunitpath')
            });
        }
    }

    // save the data returned from mesoAdevent into a state, so we can tell if the selected ad is house ad or not
    trackAdsUnitState({ detail } = {}) {
        if (!detail) {
            return;
        }
        const { adunitState = {} } = this.state || {};

        const unitState = {};
        unitState[detail.adUci] = detail;

        this.setState({ adunitState: { ...adunitState, ...unitState } });
    }

    componentDidMount() {
        /* istanbul ignore next */
        if (this.state.isBrowser) {
            window.addEventListener('blur', this.trackAdsViewByIframeClick);
            // this event gets fired from MesoAd component and it contains the ad details like type, id...etc.
            window.addEventListener('mesoAdunitState', this.trackAdsUnitState);
        }
    }

    componentWillUnmount() {
        if (this.state.isBrowser) {
            window.removeEventListener('blur', this.trackAdsViewByIframeClick);
            window.removeEventListener('mesoAdunitState', this.trackAdsViewByIframeClick);
            this.setState({ adunitState: {} });
            removeAdsScripts();
        }
    }

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

MesoAdsContext.propTypes = {
    brandId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    havId: PropTypes.string.isRequired,
    isAdsEnabled: PropTypes.bool.isRequired,
    gaiaId: PropTypes.string
};
